import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		// ?safe&mock-data&utm_source=FB&country=US&area=main&exp=web_main_article_longread~1
		main: {
			landing: {
				ids: ['article-main', 'loader-main', 'age-main'],
			},
		},
	},
]

export default config
